import api from './api'

/**
 * 获取产品标签列表
 * @param {Object} params 查询参数
 * @param {string} params.code 标签编码（精确查询，可选）
 * @param {string} params.remark 标签说明（模糊查询，可选）
 * @param {boolean} params.is_active 启用状态（精确查询，可选）
 * @param {number} params.skip 跳过记录数（可选）
 * @param {number} params.limit 每页条数（可选）
 * @returns {Promise} 包含tags、total、page、size的对象
 */
export async function getProductTags(params) {
  const res = await api.get('/api/v1/product-tags', { params })
  return res.data
}

/**
 * 创建产品标签
 * @param {Object} tagData 标签数据
 * @param {string} tagData.code 标签编码（A-X）
 * @param {boolean} tagData.is_active 是否启用
 * @param {number} tagData.sort 排序
 * @param {string} tagData.remark 标签说明
 * @returns {Promise}
 */
export async function createProductTag(tagData) {
  const res = await api.post('/api/v1/product-tags/create', tagData)
  return res.data
}

/**
 * 更新产品标签（不支持修改code）
 * @param {string|number} id 标签ID
 * @param {Object} tagData 标签数据
 * @param {boolean} tagData.is_active 是否启用（可选）
 * @param {number} tagData.sort 排序（可选）
 * @param {string} tagData.remark 标签说明（可选）
 * @returns {Promise}
 */
export async function updateProductTag(id, tagData) {
  const res = await api.put(`/api/v1/product-tags/update/${id}`, tagData)
  return res.data
}
